import { callMethodOnKeydown, isTyping } from '../helpers'
import { viewport } from '../map_state/viewport'

class MoveToCenterTool {
  constructor () {
    this.element = document.getElementById('mct-move-to-center')
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)

    viewport.scrollToCenter = viewport.scrollToCenter.bind(viewport)
    this.element.addEventListener('click', viewport.scrollToCenter)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', viewport.scrollToCenter)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'm') callMethodOnKeydown(e.target, viewport.scrollToCenter)
  }
}

export let moveToCenterTool = null

export function initMoveToCenterTool () {
  moveToCenterTool = new MoveToCenterTool()
  return moveToCenterTool
}
